import { data } from '@portal/pkg-api/shared'
import { EntityTypeApi } from '@portal/pkg-api/navigator'
import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

const prefix = 'shared.entityType'

export const EntityTypeQueries = {
  allEntityTypes: () => ({
    queryKey: [`${prefix}.allEntityTypes`],
    queryFn: () => data(EntityTypeApi.getEntityTypes()),
  }),
  userEntityTypes: () => ({
    queryKey: [`${prefix}.userEntityTypes`],
    queryFn: async () => {
      const response = await data(EntityTypeApi.getEntityTypes())
      return response.filter(({ enabled }) => enabled)
    },
  }),
  getEntityType: (id?: number) => ({
    queryKey: [`${prefix}.entityType`, id],
    queryFn: async () => {
      return data(EntityTypeApi.getEntityType(id!))
    },
    enabled: !!id,
  }),
}

export function useUserEntityTypes() {
  return useQuery(EntityTypeQueries.userEntityTypes())
}

export function useEntityTypeLookup() {
  const entityTypes = useQuery(EntityTypeQueries.allEntityTypes())

  return useMemo(() => {
    if (!entityTypes.data) return {}

    const map: Record<string, (typeof entityTypes.data)[0]> = {}
    entityTypes.data.forEach((et) => {
      map[et.id] = { ...et }
    })
    return map
  }, [entityTypes])
}
